import { useEffect, useState } from "react"
import { getMultiCall, getStakingContract, getMultiCallContract } from "../helper/contractHelper";
import { useAccount } from "wagmi";



export const useCommonStats = (update) => {
  const [stats, setStats] = useState({
    totalRewardsDistribution: 0,
    totalStake: 0,
    totalWithdrawal: 0,
    emergencyWithdrawFees : 0
  });

  const sc = getStakingContract()

  useEffect(() => {
    const fetch = async () => {

      const data = await getMultiCall([
        sc.methods.totalRewardsDistribution(),
        sc.methods.totalStake(),
        sc.methods.totalWithdrawal(),
        sc.methods.emergencyWithdrawFees()
      ]);

      setStats({
        totalRewardsDistribution: data[0] / Math.pow(10, 18),
        totalStake: data[1] / Math.pow(10, 18),
        totalWithdrawal: data[2] / Math.pow(10, 18),
        emergencyWithdrawFees : data[3] / 100
      });
    }


    fetch();

    // eslint-disable-next-line
  }, [update]);

  return stats;
}

export const useAccountStats = (updater) => {
  const { address } = useAccount();
  const [stats, setStats] = useState({
    balance: 0,
    totalStake: 0,
    orderIds: '',
    totalRewardEarn: 0
  });

  const sc = getStakingContract();
  const mcc = getMultiCallContract();


  useEffect(() => {
    const fetch = async () => {
      const data = await getMultiCall([
        mcc.methods.getEthBalance(address),
        sc.methods.balanceOf(address),
        sc.methods.investorOrderIds(address),
        sc.methods.totalRewardEarn(address)
      ]);

      setStats({
        balance: data[0] / Math.pow(10, 18),
        totalStake: data[1] / Math.pow(10, 18),
        orderIds: data[2],
        totalRewardEarn: data[3] / Math.pow(10, 18)
      })
    }

    if (address) {
      fetch();
    }
    else {
      setStats({
        balance: 0,
        totalStake: 0,
        orderIds: '',
        totalRewardEarn: 0
      })
    }
    // eslint-disable-next-line
  }, [address, updater]);

  return stats;
}
